import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularStake: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_stake"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="stake icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M2.71633 20.2174L19.3063 3.61038H15.4398C14.9954 3.61038 14.6352 3.25015 14.6352 2.80578C14.6352 2.36141 14.9954 2.00118 15.4398 2.00118H22.0004V8.62175C22.0004 9.06612 21.6401 9.42635 21.1958 9.42635C20.7514 9.42635 20.3912 9.06612 20.3912 8.62175V4.80297L3.85395 21.3572C3.53977 21.6717 3.03052 21.6717 2.71633 21.3572C2.40195 21.0425 2.40195 20.5321 2.71633 20.2174Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5303 6.2699C10.5303 8.62843 8.6204 10.5398 6.26516 10.5398C3.90991 10.5398 2 8.62843 2 6.2699C2 3.91136 3.90991 2 6.26516 2C8.6204 2 10.5303 3.91136 10.5303 6.2699ZM6.26516 8.9306C7.73001 8.9306 8.92112 7.74136 8.92112 6.2699C8.92112 4.79844 7.73001 3.6092 6.26516 3.6092C4.8003 3.6092 3.6092 4.79844 3.6092 6.2699C3.6092 7.74136 4.8003 8.9306 6.26516 8.9306Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.0003 17.753C22.0003 20.0989 20.1007 22 17.7581 22C15.4155 22 13.5159 20.0989 13.5159 17.753C13.5159 15.4072 15.4155 13.5061 17.7581 13.5061C20.1007 13.5061 22.0003 15.4072 22.0003 17.753ZM17.7581 20.3908C19.2103 20.3908 20.3911 19.2118 20.3911 17.753C20.3911 16.2942 19.2103 15.1153 17.7581 15.1153C16.3059 15.1153 15.1251 16.2942 15.1251 17.753C15.1251 19.2118 16.3059 20.3908 17.7581 20.3908Z"
        />
      </svg>
    </span>
  );
};

export { RegularStake };
